/* DECROS - varyant degisince ozel bloklari tazele.
   Kurulum + varyant haritasi: snippets/decros-variant-sync.liquid

   NEDEN ONBELLEK (3 Eyl 2026, Ahmet: "bastiktan bir saniye sonra
   oluyor, aninda yapabilir miyiz?"): gecikme bizden degildi.
   Dawn tiklayinca bolumu sunucudan cekiyor, cevap gelince olayini
   yayinliyor; biz o ag gidis-donusunu bekliyorduk. Simdi kutunun
   uzerine gelindiginde varyant arka planda cekilip bellege
   aliniyor, kalanlar sayfa bosken. Tiklamada ag beklenmiyor.
   Dawn'in olayi yine de dinleniyor: dogruluk emniyeti. */
(function () {
  if (window.dcVariantSyncKuruldu) return;
  window.dcVariantSyncKuruldu = true;

  var SECICILER = ['a.decros-cta', '.decros-specs', 'decros-calc', '.dc-price'];
  var onbellek = new Map();
  var ucus = new Map();
  var sonUygulanan = null;

  function vs() { return document.querySelector('variant-selects'); }

  function harita() {
    var el = document.getElementById('dc-variant-map');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function bolumId() {
    var v = vs();
    if (v && v.dataset && v.dataset.section) return v.dataset.section;
    var k = document.querySelector('.product__info-container');
    k = k && k.closest('.shopify-section');
    return k ? k.id.replace(/^shopify-section-/, '') : null;
  }

  /* Varyant basligi = secenek degerlerinin " / " ile birlesimi.
     aday: o an tiklanan/uzerine gelinen input (varsa) kendi
     grubunda secili sayilir. Cok secenekli urunlerde de calisir. */
  function baslikIcin(aday) {
    var v = vs(); if (!v) return null;
    var gruplar = v.querySelectorAll('fieldset.product-form__input');
    if (!gruplar.length) return null;
    var parca = [];
    for (var i = 0; i < gruplar.length; i++) {
      var g = gruplar[i], t = null;
      if (aday && g.contains(aday)) t = aday;
      else t = g.querySelector('input:checked');
      if (!t) return null;
      parca.push(t.value);
    }
    return parca.join(' / ');
  }

  function idIcin(aday) {
    var h = harita(); if (!h) return null;
    var b = baslikIcin(aday);
    return b && h[b] ? String(h[b]) : null;
  }

  function getir(id) {
    if (onbellek.has(id)) return Promise.resolve(onbellek.get(id));
    if (ucus.has(id)) return ucus.get(id);
    var sid = bolumId();
    if (!sid) return Promise.resolve(null);
    var p = fetch(location.pathname + '?variant=' + encodeURIComponent(id) +
                  '&section_id=' + encodeURIComponent(sid))
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        onbellek.set(id, d); ucus.delete(id); return d;
      })
      .catch(function (e) { ucus.delete(id); console.warn('[decros] varyant:', e); return null; });
    ucus.set(id, p);
    return p;
  }

  function degistir(kaynak) {
    if (!kaynak || !kaynak.querySelector) return;
    SECICILER.forEach(function (s) {
      var yeni = kaynak.querySelector(s), eski = document.querySelector(s);
      if (yeni && eski) eski.replaceWith(yeni.cloneNode(true));
    });
  }

  function uygula(id, kaynak) {
    if (!kaynak || id === sonUygulanan) return;
    sonUygulanan = id;
    degistir(kaynak);
  }

  /* 1) Tiklamada: onbellekte varsa AYNI KAREDE degistir. */
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t.closest || !t.closest('variant-selects')) return;
    var id = idIcin(t);
    if (!id) return;
    if (onbellek.has(id)) uygula(id, onbellek.get(id));
    else getir(id).then(function (d) { uygula(id, d); });
  }, true);

  /* 2) Uzerine gelince onden cek. */
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (olay) {
    document.addEventListener(olay, function (ev) {
      var t = ev.target;
      if (!t.closest || !t.closest('variant-selects')) return;
      var inp = t.closest('label') ? t.closest('label').control : t;
      if (!inp || inp.tagName !== 'INPUT') inp = t.querySelector ? t.querySelector('input') : null;
      var id = idIcin(inp);
      if (id && !onbellek.has(id)) getir(id);
    }, true);
  });

  /* 3) Sayfa bosken kalan varyantlari da cek. */
  function onIsit() {
    var h = harita(); if (!h) return;
    var idler = Object.keys(h).map(function (k) { return String(h[k]); });
    var i = 0;
    (function sonraki() {
      if (i >= idler.length) return;
      var id = idler[i++];
      if (onbellek.has(id)) return sonraki();
      getir(id).then(function () { setTimeout(sonraki, 60); });
    })();
  }
  if ('requestIdleCallback' in window) requestIdleCallback(onIsit, { timeout: 4000 });
  else setTimeout(onIsit, 1800);

  /* 4) Dawn'in kendi olayi — dogruluk emniyeti. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var d = e && e.data; if (!d) return;
      var id = d.variant && d.variant.id ? String(d.variant.id) : null;
      if (d.html) { if (id) onbellek.set(id, d.html); uygula(id || 'dawn', d.html); return; }
      if (id) getir(id).then(function (k) { uygula(id, k); });
    });
  }
})();
